import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ReviewSubmittedDialogComponent} from "../review-submitted-dialog/review-submitted-dialog.component";
import {MerchantApi} from "../../../../../common/apis/merchant-api";
import {ProductApi} from "../../../../../common/apis/product-api";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-write-review-dialog',
  templateUrl: './write-review-dialog.component.html',
  styleUrls: ['./write-review-dialog.component.scss']
})
export class WriteReviewDialogComponent implements OnInit {

  rate: number = 0
  form: FormGroup = new FormGroup({});
  control: FormControl = new FormControl()
  isLoading: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string, isProduct: boolean },
    public dialogRef: MatDialogRef<WriteReviewDialogComponent>,
    public dialog: MatDialog,
    private merchantApi: MerchantApi,
    private productApi: ProductApi
  ) {
  }

  ngOnInit(): void {
    this.form.addControl('comment', this.control)
  }

  closeDialog() {
    this.dialogRef.close()
  }

  setRate(rate: number) {
    this.rate = rate
  }

  getStarsImage(index: number): string {
    if (this.rate >= (index + 1)) {
      return "assets/star-icon.svg"
    } else {
      return "assets/empty-star.svg"
    }
  }

  submitRate() {
    let apiCall;
    this.isLoading = true
    if (this.data.isProduct) {
      apiCall = this.productApi.writeReview(this.data.id, this.rate, this.form.get('comment')?.value ?? "")
    } else {
      apiCall = this.merchantApi.writeReview(this.data.id, this.rate, this.form.get('comment')?.value ?? "")
    }
    apiCall.subscribe({
      next: (_) => {
        this.isLoading = false
        this.closeDialog()
        this.dialog.open(ReviewSubmittedDialogComponent, {
          width: '37rem'
        });
      },
      error: (err) => {
        this.isLoading = false
        console.log("Submit rate error", err)
      }
    })
  }
}
